const videoResponsive = (): void => {
  const videos = document.querySelectorAll<HTMLIFrameElement>('.content-box iframe')
  for (const video of videos) {
    function setIframeHeight (): void {
      const container: HTMLElement | null = video.parentElement
      if (container) {
        const aspectRatio: number = 16 / 9
        const width: number = container.offsetWidth
        const calculatedHeight: number = width / aspectRatio
        video.style.height = calculatedHeight + 'px'
      }
    }

    function handleOrientationChange (): void {
      setTimeout(setIframeHeight, 300)
    }

    window.addEventListener('load', setIframeHeight)
    window.addEventListener('resize', setIframeHeight)
    window.addEventListener('orientationchange', handleOrientationChange)
  }
}

export default videoResponsive
